module.exports = "<go-wrapper [title]=\"'Запускает переход в ивент'\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n  <nv-game-events [document]=\"document\"\n                  [propertyName]=\"'eventStarterComponent'\"></nv-game-events>\n\n\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-event-starter/go-event-starter.component.html
// module id = ../../../../../src/app/components/go/go-event-starter/go-event-starter.component.html
// module chunks = 0